<template>
  <div>
    <section class="invoice">
      <!-- title row -->
      <div class="row">
        <div class="col-xs-12">
          <h2 class="page-header">
            <i class="fa fa-shopping-cart"></i> Vos commandes
          </h2>
        </div>
      </div>

      <div class="portlet-body">

        <vue-simple-spinner
          :size="64"
          message="Chargement en cours..."
          :spacing="25"
          text-fg-color="#FFF"
          :font-size="16"
          v-if="loading"
        ></vue-simple-spinner>

        <div v-if="!loading">
          <b-table responsive bordered striped hover
                   :items="orderList"
                   :fields="table.columns"
                   :filter="table.filter"
                   :per-page="table.perPage"
                   empty-text="Données indisponibles"
                   :current-page="table.currentPage"
                   :sort-compare="$sortCompareAdvanced"
                   :no-sort-reset="true"
                   :empty-text="'Aucun résultat'"
                   :empty-filtered-text="'Aucun résultat'"
                   show-empty
                   :sort-by.sync="table.sortBy"
                   :sort-desc.sync="table.sortDesc"
          >

            <template v-slot:cell(zoom)="row">
              <button class="btn btn-default btn-xs  pull-left"
                      @click.stop="row.toggleDetails"
              >
                <i class="fa"
                   :class="{'fa-search-plus':!row.detailsShowing,'fa-search-minus':row.detailsShowing}"
                >
                </i>
              </button>
            </template>

            <template v-slot:cell(numero)="data">
              <span>{{ data.item.numero }}</span>
            </template>

            <template v-slot:cell(date)="data">
              <span>{{ data.item.date }}</span>
            </template>

            <template v-slot:cell(order_payed)="data">
              <span v-if="data.item.order_payed" class="text-green">Payement reçu</span>
              <span v-if="!data.item.order_payed" class="text-warning">Payement non-reçu</span>

            </template>

            <template v-slot:cell(total)="data">
              <span>{{ data.item.total.toFixed(2).replace(".", ",") }}€</span>
            </template>

            <template v-slot:cell(statut)="data">
                        <span
                          :class="$getClassNameRecap(data.item.statut)">
                            {{ data.item.statut }}
                    </span>
            </template>

            <template v-slot:row-details="data">
              <b-card>
<!--                  <template v-for="product in data.item.products">-->
<!--                    <b-col sm="12" class="text-sm-right">-->
<!--                      • {{ product.product_name }} <strong>{{ product.orderable_name }}</strong>-->
<!--                      : {{ product.cost.toFixed(2).replace(".", ",") }}€</em>-->
<!--                    </b-col>-->
<!--                  </template>-->

                  <div class="row">
                    <div class="col-sm-12 table-responsive">
                      <table class="table table-condensed table-striped">
                        <thead>
                        <tr >
                          <th>Quantité</th>
                          <th>Produit</th>
                          <th>Description</th>
                          <th>Dates de licence</th>
                          <th class="alignright">Total</th>
                        </tr>
                        </thead>
                        <tbody>
                        <template v-if="data.item.products">
                          <tr v-for="product in data.item.products">
                            <td>1x</td>
                            <td>{{product.product_name}}</td>
                            <td>
                              {{ product.orderable_name}}
                            </td>
                            <td>
                              {{formatDate(product.date_debut, 'YYYY-MM-DD', 'DD/MM/YYYY')}}
                              -
                              {{formatDate(product.date_fin, 'YYYY-MM-DD', 'DD/MM/YYYY')}}
                            </td>
                            <td>{{product.cost.toFixed(2).replace(".", ",")}} €</td>
<!--                            <td class="alignright">{{ getTotalFromCart('licence_renew').toFixed(2).replace(".", ",") }}€</td>-->
                          </tr>
                        </template>
                        </tbody>
                      </table>
                    </div>
                  </div>
              </b-card>
            </template>
          </b-table>

          <div class="row">
            <b-pagination
              style="margin-top: 0;"
              size="md" :total-rows="orderList.length" v-model="table.currentPage"
              :per-page="table.perPage"></b-pagination>
            <b-col md="6" class="pull-right my-1">
              <div style="display:inline-block" class="margin-r-5; pull-right">
                <span style="display:inline-block">Par Page:</span>
                <select class="form-control" v-model="table.perPage"
                        style="display:inline-block;width: 100px;">
                  <option :value="20">20</option>
                  <option :value="50">50</option>
                  <option :value="75">75</option>
                  <option :value="100">100</option>
                  <option :value="999999">Tout</option>
                </select>
              </div>
            </b-col>
          </div>

        </div>
      </div>

    </section>
  </div>
</template>

<script type="text/babel">
import Auth from '@/auth'
import moment from 'moment/moment'
import {mapGetters, mapActions} from 'vuex'
import stepsOrder from '../stepsOrder'
let _ = require('lodash')

export default {
  data() {
    return {
      loading: true,
      orderList: [],
      table: {
        filter: '',
        sortBy: 'date_fin',
        sortDesc: true,
        currentPage: 1,
        perPage: 50,
        columns: [
          {
            label: 'Détails',
            key: 'zoom',
          },
          {
            label: 'Numéro',
            key: 'numero',
            sortable: true,
          },
          {
            label: 'Date',
            key: 'date',
            sortable: true,
          },
          {
            label: 'Prix total',
            key: 'total',
            sortable: true,
          },
          {
            label: 'Statut',
            key: 'statut',
            sortable: true
          },
          {
            label: 'Payement',
            key: 'order_payed',
            sortable: true
          }
        ],
      }
    }
  },
  mounted: function () {
    this.getOrderList();
  },
  methods: {
    ...mapActions({}),
    formatDate: function (value, ftmIn, fmtOut) {
      if (value == null) return ''
      fmtOut = (typeof fmtOut == 'undefined') ? 'DD/MM/YYYY HH:mm' : fmtOut
      return moment(value, ftmIn).format(fmtOut)
    },
    getOrderList: function () {
      this.loading = true
      // console.log({id_club: this.getIdClubSelected})
      this.$http.post(process.env.API_URL + "getOrderList", {id_club: this.getIdClubSelected})
        .then((response) => {
          this.loading = false
          return this.orderList = response.body.data
        }, (response) => {
          this.loading = false
          return this.$noty.error("Erreur lors de l'obtention de la liste de vos commandes.")
        })

    },
  },
  components: {
    stepsOrder
  },
  computed: {
    ...mapGetters({
      getCart: 'getCart',
      getIdClubSelected: 'getIdClubSelected',
    })
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Order/OrderList.vue